import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useGetSelfAdminUserQuery } from '../../API/administration/AdminUsersAPI';
import { createDefaultSearchOrderSpecification } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export const LinkToMyOrders: React.FC<{ setOpen: React.Dispatch<React.SetStateAction<boolean>> }> = ({ setOpen }) => {
  const { data } = useGetSelfAdminUserQuery();
  const to = useMemo(() => {
    const searchOrdersSpecification = createDefaultSearchOrderSpecification();
    if (data) {
      searchOrdersSpecification.internalContactAdminId = data.id;
    }
    return clientUrls.urlFor.adminOrders(searchOrdersSpecification);
  }, [data]);

  return (
    <Link
      to={to}
      onClick={() => setOpen(false)}
      className={
        'flex cursor-pointer flex-row content-center gap-2 text-sm/6 font-normal text-slate-400 hover:text-slate-900 hover:underline'
      }
    >
      See My Orders <ArrowTopRightOnSquareIcon className={'inline h-5 w-5'} />
    </Link>
  );
};
